import { render, staticRenderFns } from "./InfoTitle.vue?vue&type=template&id=4e58d425&scoped=true&"
import script from "./InfoTitle.vue?vue&type=script&lang=js&"
export * from "./InfoTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoTitle.vue?vue&type=style&index=0&id=4e58d425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e58d425",
  null
  
)

export default component.exports